export function element<T extends Element>(selector: string, root: ParentNode = document): T {
  const result = root.querySelector<T>(selector);
  if (!result) throw new Error(`Required DOM element not found: ${selector}`);
  return result;
}

export function optionalElement<T extends Element>(selector: string): T | null {
  return document.querySelector<T>(selector);
}

export function elements<T extends Element>(selector: string): T[] {
  return Array.from(document.querySelectorAll<T>(selector));
}
